import { SocialMediaIcon } from 'components/Layout/Footer/FooterSocialMedia/SocialMediaIcon';
import { FooterSettingSocialItemType } from 'types/footerSetting';

type SocialMediaProps = {
    socialSection: FooterSettingSocialItemType[];
};

export const FooterSocialMedia: FC<SocialMediaProps> = ({ socialSection }) => {
    if (socialSection.length === 0) {
        return null;
    }

    return (
        <div className="flex w-full flex-row flex-wrap items-center justify-center gap-x-10 gap-y-12 pb-10 vl:pb-12">
            {socialSection.map((socialMediaItem, index) => (
                <SocialMediaIcon
                    key={index}
                    hoverImage={socialMediaItem.hoverImage ?? null}
                    hoverImageTitle={socialMediaItem.hoverImageTitle}
                    linkActionTitle={socialMediaItem.linkActionTitle}
                    mainImage={socialMediaItem.mainImage ?? null}
                    mainImageTitle={socialMediaItem.mainImageTitle}
                    position={socialMediaItem.position}
                    socialMediaName={socialMediaItem.socialMediaName}
                    url={socialMediaItem.url}
                />
            ))}
        </div>
    );
};
